export default "__VITE_ASSET__CLaHuTqO__"